'use strict';

var customSwal = require('./customSwal');

/**
 * Builds the toast markup.
 *
 * @param {{ message?: string, error?: boolean, iconClass?: string, ctaUrl?: string, ctaLabel?: string}} payload
 * @returns {string}
 */
function buildHtml(payload) {
    var isError = !!payload.error;
    var isWarning = !!payload.warning && !isError;
    var message = payload.message || '';
    var iconClass = payload.iconClass || (isError ? 'icon-close' : 'icon-check');
    var statusModifier = isError ? ' sa-generic-toast--error' : (isWarning ? ' sa-generic-toast--warning' : '');
    var ctaHtml = '';

    if (!isError && payload.ctaUrl && payload.ctaLabel) {
        ctaHtml = '<a class="btn btn--primary sa-generic-toast__cta" href="' + payload.ctaUrl + '">' + payload.ctaLabel + '</a>';
    }

    return (
        '<div class="sa-generic-toast' +
        statusModifier +
        '" role="status" aria-live="polite">' +
        '<div class="sa-generic-toast__status">' +
        '<span class="sa-generic-toast__icon" aria-hidden="true">' +
        '<i class="' +
        iconClass +
        '"></i>' +
        '</span>' +
        '<p class="sa-generic-toast__message">' +
        message +
        '</p>' +
        '</div>' +
        ctaHtml +
        '</div>'
    );
}

/**
 * Opens the toast; replaces any visible SweetAlert2 instance first.
 *
 * @param {{ message?: string, error?: boolean, iconClass?: string, ctaUrl?: string, ctaLabel?: string}} payload
 * @returns {Promise}
 */
function show(payload) {
    if (customSwal.Swal.isVisible()) {
        customSwal.Swal.close();
    }

    return customSwal.openToast(
        Object.assign({}, payload, {
            html: buildHtml(payload),
        })
    );
}

module.exports = {
    show: show,
};
